import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";
import { breakpoints } from "../../constants/breakpoints";

const styles = createUseStyles(theme => ({
  inputWrapper: {
    position: "relative",
    width: "100%",
    maxWidth: "400px",
  },
  input: {
    height: "44px",
    width: "100%",
    border: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    padding: "0 0 0 50px",
    "&:focus": {
      outline: "none"
    },
    "&::placeholder": {
      color: colors.inactiveGrey,
    },
    "&.inputError": {
      border: "1px solid " + colors.mediumRed + " !important",
    },
  },
  icon: {
    position: "absolute",
    left: "16px",
    top: "8px"
  },
  spinner: {
    position: "absolute",
    left: "16px",
    top: "50%",
    marginLeft: 0,
    height: "20px",
    transform: "translate( 0%, -50%)"
  }
}));

export default styles;
